import { auth0ApiClient } from './auth0ApiClient'
import { User, UpdateProfileRequest, NotificationPreferences } from '@/types/user'

export interface ProfileUpdateData {
  firstName?: string
  lastName?: string
  bio?: string
  expertise?: string[]
  interests?: string[]
  goals?: string[]
  maxMentees?: number
  isAvailable?: boolean
  notificationPreferences?: Partial<NotificationPreferences>
}

export interface ProfilePictureUploadResult {
  profilePicture?: string
}

class ProfileService {
  async getProfile(): Promise<User> {
    return auth0ApiClient.get<User>('/users/profile')
  }

  async getUserById(userId: string): Promise<User> {
    return auth0ApiClient.get<User>(`/users/${userId}`)
  }

  async updateProfile(data: ProfileUpdateData): Promise<User> {
    // Transform the data to match the API structure
    const updateData: UpdateProfileRequest = {
      firstName: data.firstName,
      lastName: data.lastName,
      profile: {
        bio: data.bio,
        expertise: data.expertise || [],
        interests: data.interests || [],
        goals: data.goals || [],
        maxMentees: data.maxMentees,
        isAvailable: data.isAvailable,
      },
      notificationPreferences: data.notificationPreferences,
    }

    return auth0ApiClient.put<User>('/users/profile', updateData)
  }

  async changePassword(): Promise<void> {
    await auth0ApiClient.post<void>('/users/change-password')
  }

  async uploadProfilePicture(file: File): Promise<ProfilePictureUploadResult> {
    const formData = new FormData()
    formData.append('file', file)
    return auth0ApiClient.upload<ProfilePictureUploadResult>('/users/profile/picture', formData)
  }

  async deleteProfilePicture(): Promise<ProfilePictureUploadResult> {
    return auth0ApiClient.delete<ProfilePictureUploadResult>('/users/profile/picture')
  }
}

export const profileService = new ProfileService()